export default {
	"order.CongratulationsOnYourSuccessfulPurchase": "恭喜你购买成功",
	"order.TheCouponHasBeenPlacedInYourPersonalAccountYouCanLogInToTheCallAppOrAppletToViewIt": "优惠券已放入您的个人帐户中，可登录【叫叫】App或小程序进行查看",
	"order.checkOrder": "查看订单",
	"order.LongPressOrScanTheQRCodeToIdentifyTheCallingApplet": "长按或扫描二维码识别叫叫小程序"
}